export default "__VITE_PUBLIC_ASSET__4cbae111__"